import { cn } from '../../lib/utils';
import { PageDescription, PanelTitle } from '../layout/Typography';

interface EmptyStateProps {
  icon?: React.ReactNode;
  title: string;
  description?: string;
  action?: React.ReactNode;
  variant?: 'default' | 'bordered' | 'fullHeight';
  className?: string;
}

export function EmptyState({
  icon,
  title,
  description,
  action,
  variant = 'default',
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center text-center',
        variant === 'fullHeight' && 'h-full p-4 md:p-6',
        variant === 'bordered' && 'rounded-lg border border-dashed border-border py-8',
        variant === 'default' && 'py-10',
        className,
      )}
    >
      {icon &&
        (variant === 'bordered' ? (
          <div className="mb-2 text-muted-foreground/40">{icon}</div>
        ) : (
          <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl border border-border/30 bg-transparent">
            {icon}
          </div>
        ))}
      <PanelTitle as="p" size="sm" truncate={false} className="text-muted-foreground">
        {title}
      </PanelTitle>
      {description && <PageDescription className="max-w-sm text-xs">{description}</PageDescription>}
      {action && <div className="mt-4">{action}</div>}
    </div>
  );
}
